import { Box, Steps, StepsRootProps } from '@chakra-ui/react'
import { Text } from '.'

export interface Props extends Omit<StepsRootProps, 'onChange' | 'children'> {
  steps: StepperStep[]
  onChange?: (index: number) => void
}

export interface StepperStep {
  title: string
  description?: string
  canClick?: boolean
}

export default function Stepper({ onChange, steps, ...rest }: Props) {
  return (
    <Steps.Root count={steps.length} {...rest}>
      <Steps.List>
        {steps.map(({ title, description, canClick }, index) => (
          <Steps.Item
            key={index}
            index={index}
            onClick={canClick ? () => onChange?.(index) : undefined}
            style={{ cursor: canClick ? 'pointer' : 'default' }}
          >
            <Steps.Indicator />
            <Box>
              <Steps.Title>
                <Text textStyle="bodyMedium" opacity={canClick ? 1 : 0.2}>
                  {title}
                </Text>
              </Steps.Title>
              {description && (
                <Text mt={1} textStyle="bodySmall" opacity={canClick ? 0.6 : 0.2}>
                  {description}
                </Text>
              )}
            </Box>
            <Steps.Separator />
          </Steps.Item>
        ))}
      </Steps.List>
    </Steps.Root>
  )
}
